module.exports = __webpack_public_path__ + "static/ranger_icon-7ec843f8c261e41f1bce866cc878b89e.png";